// Angular imports
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CKEditorModule } from 'ng2-ckeditor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppComponent } from './app.component';
import { routing } from './app.routing';

import { CoreModule } from './core/core.module';
import { AuthService } from './core/services/auth.service';
import { TokenInterceptor } from './core/services/token.interceptor';
import { TokenGS1Service } from './core/services/tokenGS1.service';
import { Gs1ComponentsLibraryModule } from '@gs1france/gs1-components-library';
import { lastValueFrom } from 'rxjs';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PipesModule } from "./core/Pipe/question/filterquestions.module";
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

registerLocaleData(localeFr, 'fr');

@NgModule({
    providers: [
        {provide: APP_INITIALIZER, useFactory: appInitializerFactory, deps: [TranslateService], multi: true},
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
        {provide: 'googleTagManagerId', useValue: 'GTM-MRWFXTG'},
        { provide: OAuthStorage, useFactory: getLocalStorage },
        AuthService, OAuthService, TokenGS1Service,
        {provide: APP_INITIALIZER, useFactory: (initService: AuthService) => initService.initAuth(), deps: [AuthService], multi: true},
        { provide: LOCALE_ID, useValue: "fr" }
    ],
    declarations: [
        AppComponent,
        UnauthorizedComponent
    ],
    imports: [
        CoreModule,
        PipesModule,
        CommonModule, BrowserAnimationsModule, HttpClientModule,
        BrowserModule, FormsModule, ReactiveFormsModule,
        CKEditorModule,
        OAuthModule.forRoot(),
        TypeaheadModule.forRoot(),
        RouterModule.forRoot(routing, { enableTracing: false }),
        ModalModule.forRoot(),
        Gs1ComponentsLibraryModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: false
        }),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {}
}

export function getLocalStorage() {
    return (typeof window !== "undefined") ? window.localStorage : null;
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
export function appInitializerFactory(translate: TranslateService) {
    return async () =>  {
        try {
            translate.setDefaultLang('fr');
            await lastValueFrom(translate.use('fr'));
            console.info(`Successfully initialized language.`);
        } catch(err) {
            console.error(`Problem with language initialization.`);
            console.error(err);
        }
    }
}